import { useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import api from "../../services/api";

export default function Report() {
  const history = useHistory();

  const downloadReport = useCallback(async () => {
    try {
      const { data } = await api.get("/people", { responseType: "blob" });

      const blob = new Blob([data]);

      const outputFilename = `peixe-solidario-relatorio-${new Date().toLocaleDateString('pt-BR').replaceAll('/', '-')}.xlsx`;

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', outputFilename);
      document.body.appendChild(link);
      link.click();

      history.goBack();
    } catch (error) {
      console.log(error);
      toast.error("Erro ao gerar relatório.");
      history.goBack();
    }
  }, [history]);

  useEffect(() => {
    downloadReport();
  }, [downloadReport]);

  return null;
}
